// @ts-nocheck
import React from "react";
import { AlertTriangle, XCircle, Info, CheckCircle2 } from "lucide-react";
import { cn } from "@/lib/utils";

export const NotifIcon = ({ type }) => {
  const icons = {
    warning: AlertTriangle,
    error: XCircle,
    info: Info,
    success: CheckCircle2,
  };
  const colors = {
    warning: "text-amber-500",
    error: "text-rose-500",
    info: "text-blue-500",
    success: "text-emerald-500",
  };
  const I = icons[type] || Info;
  return <I className={cn("w-4 h-4", colors[type])} />;
};
